import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const Toaster = (action, message) => {
  return action === "success"
    ? toast.success(`${message}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
    : toast.error(`${message}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
};

export default Toaster;
